import { isOwnMessage, isRevokedMessage } from './messageEditModel';

export const REVOCABLE_MESSAGE_TYPES = Object.freeze(['TEXT', 'IMAGE']);

export function canShowMessageRevokeAction({ message, currentMemberId, writable }) {
  if (!writable) return false;
  if (!message?.serverMessageId) return false;
  if (!isOwnMessage(message, currentMemberId)) return false;
  if (isRevokedMessage(message)) return false;
  return REVOCABLE_MESSAGE_TYPES.includes(String(message.messageType || ''));
}
